(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wg-halloween"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (customElements.get('wg-halloween')) return;
  class WgHalloween extends HTMLElement {
    connectedCallback() {
      this.bootTimer = setTimeout(() => this.mount(), 0);
    }
    mount() {
      if (this.mounted || !this.isConnected) return;
      this.mounted = true;
      this.stage = this.querySelector('[data-wg-hw-stage]');
      if (!this.stage) return;
      const c = this.dataset;
      this.editor = c.editor === 'true' || Boolean(window.Shopify && window.Shopify.designMode);
      this.allowed = c.enabled === 'true' && (c.homeOnly !== 'true' || c.isHome === 'true');
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px), (max-width: 1024px) and (pointer: coarse)');
      this.intro = this.stage.querySelector('[data-wg-hw-intro]');
      this.skip = this.stage.querySelector('[data-wg-hw-skip]');
      this.spider = this.stage.querySelector('[data-wg-hw-spider]');
      this.spiderImage = this.stage.querySelector('[data-wg-hw-spider-image]');
      this.spiderStill = this.stage.querySelector('[data-wg-hw-spider-still]');
      this.web = this.stage.querySelector('[data-wg-hw-web]');
      const video=this.stage.querySelector('[data-wg-hw-video]');
      video.addEventListener('ended',()=>{if(this.introActive)this.finishIntro();},{signal:this.abort.signal});
      video.addEventListener('error',()=>{if(this.introActive)this.finishIntro();},{signal:this.abort.signal});
      document.body.appendChild(this.stage);
      const signal = this.abort.signal;
      if (this.spiderImage) this.spiderImage.addEventListener('load', () => this.syncSpiderMotion(), { signal });
      this.syncSpiderMotion();
      this.skip.addEventListener('click', () => this.finishIntro(), { signal });
      this.intro.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.finishIntro();
      }, { signal });
      document.addEventListener('keydown', (event) => {
        if (this.introActive && (event.key === 'Escape' || event.key === 'Tab')) this.finishIntro();
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && this.introActive) this.finishIntro();
      }, { signal });
      window.addEventListener('pagehide', () => this.finishIntro(), { signal });
      const refreshMotion = () => {
        this.syncSpiderMotion();
        if (this.motion.matches && this.introActive) this.finishIntro();
        this.refreshSpider();
      };
      this.motion.addEventListener('change', refreshMotion, { signal });
      this.mobile.addEventListener('change', refreshMotion, { signal });
      window.addEventListener('resize', () => { if (this.introActive) this.sizePortal(); }, { signal });
      this.querySelectorAll('[data-wg-hw-replay]').forEach((button) => {
        button.addEventListener('click', () => this.replay(), { signal });
      });
      this.querySelectorAll('[data-wg-hw-replay-spider]').forEach((button) => {
        button.addEventListener('click', () => { this.finishIntro(false); this.launchSpider(); }, { signal });
      });
      if (!this.allowed) return;
      this.stage.hidden = false;
      if (this.editor && c.editorAuto !== 'true') { this.refreshSpider(); return; }
      if (this.canPlayPortal() && this.shouldShow()) this.queuePortal();
      else this.launchSpider();
    }
    canPlayPortal() {
      return this.allowed && this.dataset.portal === 'true' && !this.motion.matches &&
        (!this.mobile.matches || this.dataset.portalMobile === 'true');
    }
    shouldShow() {
      if (this.editor || this.dataset.frequency === 'always') return true;
      if (window.__wgHalloweenPortalSeen) return false;
      try { return sessionStorage.getItem('wg-halloween-portal:v1') !== '1'; }
      catch (_) { return true; }
    }
    remember() {
      if (this.editor) return;
      window.__wgHalloweenPortalSeen = true;
      try { sessionStorage.setItem('wg-halloween-portal:v1', '1'); } catch (_) { /* accesso bloccato: resta il fallback in memoria */ }
    }
    queuePortal() {
      if(!this.canPlayPortal())return;
      const video=this.stage.querySelector('[data-wg-hw-video]');
      const url=this.mobile.matches?(video.dataset.mobile||video.dataset.desktop):video.dataset.desktop;
      if(!url){this.launchSpider();return;}
      this.portalLoadTicket={};const ticket=this.portalLoadTicket;
      const skull=this.stage.querySelector('[data-wg-hw-skull][data-enabled="true"] img');
      let timer,cleanup=()=>{};
      const ready=new Promise((resolve,reject)=>{
        const ok=()=>{if(video.readyState>=2)resolve();};
        const fail=()=>reject(new Error('video-load'));
        cleanup=()=>{video.removeEventListener('loadeddata',ok);video.removeEventListener('error',fail);};
        video.addEventListener('loadeddata',ok);video.addEventListener('error',fail);
        if(video.getAttribute('src')!==url){video.src=url;video.load();}
        else ok();
      });
      const timeout=new Promise((_,reject)=>{timer=setTimeout(()=>reject(new Error('video-timeout')),6500);});
      Promise.race([Promise.all([ready,skull?skull.decode():Promise.resolve()]),timeout]).then(()=>{
        if(this.portalLoadTicket===ticket&&this.isConnected&&this.canPlayPortal()){
          this.portalVideo=video;this.playPortal();
        }
      }).catch(()=>{if(this.portalLoadTicket===ticket&&this.isConnected)this.launchSpider();})
      .finally(()=>{clearTimeout(timer);cleanup();});
    }
    playPortal() {
      if(!this.canPlayPortal()||!this.portalVideo){this.refreshSpider();return;}
      this.finishIntro(false);
      if(!this.initVideoRenderer()){this.launchSpider();return;}
      this.spider.hidden=true;this.web.hidden=true;this.stage.hidden=false;
      this.intro.hidden=false;this.skip.hidden=false;this.intro.style.opacity='0';
      const seconds=this.mobile.matches?Number(this.dataset.mobileDuration)||4.5:Number(this.dataset.duration)||6;
      this.portalDuration=Math.max(3000,Math.min(8000,seconds*1000));
      this.intro.classList.add('is-playing');this.introActive=true;
      this.startPortal();
      this.introTimer=setTimeout(()=>this.finishIntro(),this.portalDuration+1200);
    }
    finishIntro(showSpider = true) {
      this.portalLoadTicket=null;
      clearTimeout(this.introTimer);
      this.introActive = false;
      this.stopPortal();
      if (this.intro) { this.intro.hidden = true; this.intro.classList.remove('is-playing'); }
      if (this.skip) this.skip.hidden = true;
      if (showSpider && this.allowed && this.stage) this.launchSpider();
    }
    initVideoRenderer() {
      if (this.portalGl || this.portalContext) return true;
      this.portalCanvas = this.stage.querySelector('[data-wg-hw-portal-canvas]');
      const gl = this.portalCanvas.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: false, preserveDrawingBuffer: true });
      if (!gl) {
        this.portalContext=this.portalCanvas.getContext('2d',{alpha:true});
        this.keyCanvas=document.createElement('canvas');
        this.keyContext=this.keyCanvas.getContext('2d',{willReadFrequently:true});
        return Boolean(this.portalContext&&this.keyContext);
      }
      const compile = (type, source) => {
        const shader = gl.createShader(type); gl.shaderSource(shader, source); gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error('shader');
        return shader;
      };
      try {
        const vertex = compile(gl.VERTEX_SHADER, 'attribute vec2 aPosition; varying vec2 vUv; void main(){vUv=vec2((aPosition.x+1.0)*0.5,(1.0-aPosition.y)*0.5);gl_Position=vec4(aPosition,0.0,1.0);}');
        const fragment = compile(gl.FRAGMENT_SHADER, `
          precision mediump float;
          uniform sampler2D uVideo; uniform vec2 uTexel; varying vec2 vUv;
          float green(vec3 c){return smoothstep(0.08,0.24,c.g-max(c.r,c.b))*smoothstep(0.2,0.5,c.g);}
          void main(){
            vec3 c=texture2D(uVideo,vUv).rgb;
            float key=green(c);
            vec2 d=uTexel*8.0;
            float nearGreen=max(max(green(texture2D(uVideo,vUv+vec2(d.x,0.0)).rgb),green(texture2D(uVideo,vUv-vec2(d.x,0.0)).rgb)),max(green(texture2D(uVideo,vUv+vec2(0.0,d.y)).rgb),green(texture2D(uVideo,vUv-vec2(0.0,d.y)).rgb)));
            float neutral=1.0-smoothstep(0.08,0.22,max(c.r,max(c.g,c.b))-min(c.r,min(c.g,c.b)));
            float lightning=smoothstep(0.55,0.94,min(c.r,min(c.g,c.b)))*nearGreen*neutral*(1.0-key);
            float alpha=max(1.0-min(c.r,min(c.g,c.b)),max(key,lightning));
            float edge=smoothstep(0.0,0.08,vUv.x)*smoothstep(0.0,0.08,1.0-vUv.x)*smoothstep(0.0,0.09,vUv.y)*smoothstep(0.0,0.09,1.0-vUv.y);
            alpha=smoothstep(0.018,1.0,alpha)*edge;
            // Bianco esterno trasparente, verde trasformato in profondità nera.
            gl_FragColor=vec4(vec3(lightning)*alpha,alpha);
          }`);
        const program=gl.createProgram(); gl.attachShader(program,vertex); gl.attachShader(program,fragment); gl.linkProgram(program);
        if (!gl.getProgramParameter(program,gl.LINK_STATUS)) return false;
        gl.useProgram(program);
        const buffer=gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER,buffer); gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,1,1]),gl.STATIC_DRAW);
        const position=gl.getAttribLocation(program,'aPosition'); gl.enableVertexAttribArray(position); gl.vertexAttribPointer(position,2,gl.FLOAT,false,0,0);
        const texture=gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D,texture);
        gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
        gl.uniform1i(gl.getUniformLocation(program,'uVideo'),0);
        this.portalGl=gl; this.portalProgram=program; this.portalTextureHandle=texture; this.portalBuffer=buffer; this.portalShaders=[vertex,fragment];
        this.portalTexel=gl.getUniformLocation(program,'uTexel');
        this.portalCanvas.addEventListener('webglcontextlost',(event)=>{event.preventDefault();this.finishIntro();},{signal:this.abort.signal});
        return true;
      } catch (_) { return false; }
    }
    startPortal() {
      if (!this.initVideoRenderer()) { this.finishIntro(); return; }
      this.sizePortal();
      const video=this.portalVideo;
      video.muted=true; video.currentTime=0;
      video.playbackRate=video.duration/(this.portalDuration/1000);
      video.play().then(()=>{
        if(!this.introActive){video.pause();return;}
        this.remember();
        const tick=()=>{
          if(!this.introActive||!this.isConnected||this.motion.matches)return;
          this.drawPortal();
          if(!video.ended) {
            this.videoFrameMode=Boolean(video.requestVideoFrameCallback);
            this.portalFrame=this.videoFrameMode?video.requestVideoFrameCallback(tick):requestAnimationFrame(tick);
          }
        };
        tick();
      }).catch(()=>this.finishIntro());
    }
    stopPortal() {
      if(this.portalFrame!=null) {
        if(this.videoFrameMode&&this.portalVideo)this.portalVideo.cancelVideoFrameCallback(this.portalFrame);
        else cancelAnimationFrame(this.portalFrame);
      }
      this.portalFrame=null;
      if(this.portalVideo)this.portalVideo.pause();
      if(this.portalGl)this.portalGl.clear(this.portalGl.COLOR_BUFFER_BIT);
      if(this.portalContext)this.portalContext.clearRect(0,0,this.portalCanvas.width,this.portalCanvas.height);
    }
    sizePortal() {
      if(!this.portalCanvas||!this.portalVideo||!this.portalVideo.videoWidth)return;
      const rect=this.stage.getBoundingClientRect(),v=this.portalVideo;
      this.portalWidth=rect.width;this.portalHeight=rect.height;
      this.portalDpr=Math.min(devicePixelRatio||1,2);
      const aspect=v.videoWidth/v.videoHeight;
      const cover=this.mobile.matches&&this.dataset.mobileFullscreen!=='false';
      this.stage.dataset.wgHwCover=String(cover);
      if(cover) {
        // Copertura del viewport, proporzioni originali e ritaglio centrale.
        this.portalSize=Math.max(rect.width,rect.height*aspect);
        this.portalDpr=Math.min(this.portalDpr,v.videoWidth/this.portalSize);
      } else {
        this.portalSize=Math.min(rect.width*(this.mobile.matches?.98:1),rect.height*aspect*.96,v.videoWidth/this.portalDpr);
      }
      const height=this.portalSize/aspect;
      this.portalCanvas.style.width=this.portalSize+'px';this.portalCanvas.style.height=height+'px';
      this.portalCanvas.width=Math.round(this.portalSize*this.portalDpr);this.portalCanvas.height=Math.round(height*this.portalDpr);
      if(this.keyCanvas){this.keyCanvas.width=Math.min(v.videoWidth,960);this.keyCanvas.height=Math.round(this.keyCanvas.width/aspect);}
      if(this.portalGl){this.portalGl.viewport(0,0,this.portalCanvas.width,this.portalCanvas.height);this.portalGl.uniform2f(this.portalTexel,1/v.videoWidth,1/v.videoHeight);}
      const hole=this.portalSize*(this.mobile.matches?.82:.36);
      this.stage.style.setProperty('--wg-hw-title-size',Math.min(this.mobile.matches?46:76,hole*.18)+'px');
      this.stage.style.setProperty('--wg-hw-skull-limit',Math.min(300,hole*.7)+'px');
    }
    drawPortal() {
      const gl=this.portalGl,video=this.portalVideo;
      if(!video||video.readyState<2)return;
      if(!gl){this.drawPortalCpu();this.syncVideoTimeline();return;}
      try {
        gl.bindTexture(gl.TEXTURE_2D,this.portalTextureHandle);
        gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,video);
        gl.drawArrays(gl.TRIANGLE_STRIP,0,4);
        this.syncVideoTimeline();
      } catch (_) { this.finishIntro(); }
    }
    drawPortalCpu() {
      const ctx=this.keyContext,canvas=this.keyCanvas;if(!ctx)return;
      try {
        ctx.drawImage(this.portalVideo,0,0,canvas.width,canvas.height);
        const frame=ctx.getImageData(0,0,canvas.width,canvas.height),data=frame.data;
        const output=this.portalContext.createImageData(canvas.width,canvas.height),out=output.data;
        const smooth=(a,b,n)=>{const t=Math.max(0,Math.min(1,(n-a)/(b-a)));return t*t*(3-2*t);};
        const green=i=>smooth(.08,.24,(data[i+1]-Math.max(data[i],data[i+2]))/255)*smooth(.2,.5,data[i+1]/255);
        const dx=Math.max(1,Math.round(8*canvas.width/this.portalVideo.videoWidth))*4,dy=dx*canvas.width;
        const edgeX=new Float32Array(canvas.width),edgeY=new Float32Array(canvas.height);
        for(let x=0;x<canvas.width;x++)edgeX[x]=smooth(0,.08,x/canvas.width)*smooth(0,.08,1-x/canvas.width);
        for(let y=0;y<canvas.height;y++)edgeY[y]=smooth(0,.09,y/canvas.height)*smooth(0,.09,1-y/canvas.height);
        for(let i=0;i<data.length;i+=4){
          const low=Math.min(data[i],data[i+1],data[i+2])/255,high=Math.max(data[i],data[i+1],data[i+2])/255;
          const key=green(i);let lightning=0;
          if(low>.55&&high-low<.22&&key<.9){
            const near=Math.max(green(Math.min(data.length-4,i+dx)),green(Math.max(0,i-dx)),green(Math.min(data.length-4,i+dy)),green(Math.max(0,i-dy)));
            lightning=smooth(.55,.94,low)*near*(1-smooth(.08,.22,high-low))*(1-key);
          }
          out[i]=out[i+1]=out[i+2]=Math.round(lightning*255);
          const pixel=i/4;out[i+3]=Math.round(smooth(.018,1,Math.max(1-low,key,lightning))*edgeX[pixel%canvas.width]*edgeY[Math.floor(pixel/canvas.width)]*255);
        }
        ctx.putImageData(output,0,0);
        this.portalContext.clearRect(0,0,this.portalCanvas.width,this.portalCanvas.height);
        this.portalContext.imageSmoothingEnabled=true;this.portalContext.imageSmoothingQuality='high';
        this.portalContext.drawImage(canvas,0,0,this.portalCanvas.width,this.portalCanvas.height);
      }catch(_){this.finishIntro();}
    }
    syncVideoTimeline() {
      const p=Math.max(0,Math.min(1,this.portalVideo.currentTime/this.portalVideo.duration));
      const smooth=n=>{const v=Math.max(0,Math.min(1,n));return v*v*(3-2*v);};
      this.intro.style.opacity=String(smooth(p/.07)*(1-smooth((p-.82)/.18)));
      const greeting=this.stage.querySelector('.wg-hw-greeting');
      const hasSkull=this.intro.dataset.skull==='true';
      const greet=smooth((p-.06)/.08)*(1-smooth((p-(hasSkull?.34:.43))/.10));
      greeting.style.opacity=String(greet);
      const skull=this.stage.querySelector('[data-wg-hw-skull]');
      const skullAlpha=smooth((p-.40)/.09)*(1-smooth((p-.63)/.14));
      skull.style.opacity=String(skullAlpha);
      skull.style.transform='translate(-50%,-50%) scale('+(0.86+smooth((p-.4)/.2)*.16)+')';
    }
    disposeVideoRenderer() {
      const gl=this.portalGl;if(!gl)return;
      gl.deleteTexture(this.portalTextureHandle);gl.deleteBuffer(this.portalBuffer);gl.deleteProgram(this.portalProgram);
      this.portalShaders.forEach(shader=>gl.deleteShader(shader));this.portalGl=null;
    }

    spiderAllowed() {
      return this.allowed && this.dataset.spider === 'true' &&
        (!this.mobile.matches || this.dataset.spiderMobile === 'true');
    }
    syncSpiderMotion() {
      if (!this.spiderImage || !this.spiderStill) return;
      if (!this.motion.matches) {
        this.spiderImage.hidden = false;
        this.spiderStill.hidden = true;
        return;
      }
      // Una copia ferma evita che il GIF continui a muoversi con Riduci movimento.
      this.spiderImage.hidden = true;
      if (!this.spiderImage.complete || !this.spiderImage.naturalWidth) return;
      const context = this.spiderStill.getContext('2d');
      if (!context) return;
      this.spiderStill.width = this.spiderImage.naturalWidth;
      this.spiderStill.height = this.spiderImage.naturalHeight;
      context.drawImage(this.spiderImage, 0, 0);
      this.spiderStill.hidden = false;
    }
    refreshSpider() {
      if (!this.spider || !this.web) return;
      const show = this.spiderAllowed() && !this.introActive;
      this.spider.hidden = !show;
      this.web.hidden = !show || this.dataset.web !== 'true';
    }
    launchSpider() {
      this.refreshSpider();
      if (this.spider.hidden) return;
      this.spider.classList.remove('is-dropping');
      if (!this.motion.matches) { void this.spider.offsetWidth; this.spider.classList.add('is-dropping'); }
    }
    replay() {
      if (!this.allowed) return;
      if (this.canPlayPortal()) this.queuePortal();
      else this.launchSpider();
    }
    disconnectedCallback() {
      this.portalLoadTicket=null;
      clearTimeout(this.bootTimer);
      clearTimeout(this.introTimer);
      if (this.abort) this.abort.abort();
      if (this.stage) {
        this.finishIntro(false);
        this.disposeVideoRenderer();
        this.stage.hidden = true;
        this.appendChild(this.stage);
      }
      this.mounted = false;
    }
  }
  customElements.define('wg-halloween', WgHalloween);
})();


  } catch(e) { console.error(e); }
})();
})();
